import React from 'react';
import { Link } from 'react-router-dom';

export function Logo({ to = '/', showText = true, size = 40, className = '' }) {
  return (
    <Link to={to} className={`flex items-center gap-3 group ${className}`} data-testid="veyjex-logo">
      <img
        src="/veyjex-logo.png"
        alt="VEYJEX"
        style={{ height: size, width: 'auto' }}
        className="object-contain drop-shadow-[0_0_12px_rgba(57,255,20,0.35)] transition-transform duration-300 group-hover:scale-105"
      />
      {showText && (
        <span className="font-display font-extrabold tracking-wider text-lg vj-gradient-text hidden sm:inline">
          VEYJEX
        </span>
      )}
    </Link>
  );
}
